import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter7() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          Without the insights afforded by capturing and tracking data throughout the supply chain,
          cost-saving measures like these would be virtually impossible to enact. And the economic
          impact is appreciable for food retailers and restaurants alike, whether your customers are
          peddling produce in bulk or crafting a bespoke artisanal menu, consistency is the bedrock
          of an enduring partnership.
        </p>
        <p className="chapter__paragraph">
          “Our business never stops… you can’t tell a tomato to stop growing.” Oliveri says with a
          chuckle. “And we will never be short on challenges because things will always be changing
          very rapidly.” The implications of achieving even a near lossless supply chain are
          extraordinary, in part because growers like Perfection can more reliably maximize their
          crop yields and thread the needle of forecasting demand. These data-driven innovations are
          also paving the way for more sustainable agriculture when humanity needs it most. As the
          world grapples with rapidly evolving pathogens, food insecurity, and unprecedented changes
          in climate, Perfection’s innovations in glasshouse farming and supply chain management are
          laying the groundwork for the future of mass agriculture itself. And tech powerhouses like
          Lenovo and Intel are uniquely positioned to help them build a reliable, agile
          infrastructure capable of rising to these challenges as they modernize their companies to
          embrace a new era of computing.
        </p>
      </section>
      <PullQuote
        quote={
          '“Our business never stops...you can’t tell a tomato to stop growing [...] data-driven innovations are also paving the way for more sustainable agriculture when humanity needs it most.”'
        }
        author={'— Francesco Oliveri'}
      />
      <section className="chapter">
        <p className="chapter__paragraph">
          If not for a root-level company culture that champions innovation, adaptability, and
          relentless determination, Perfection Fresh might not have sprung up out of the marketplace
          in western Sydney so long ago. These qualities are doubtlessly fundamental to the
          company’s continued success. But when you bolster them with the power of data analytics
          and scalable tech, you can just step back and watch it grow.
        </p>
      </section>
    </>
  );
}

export default Chapter7;
